<template>
  <div class="page-view pt-4 pb-4">
    <div class="container">
      <div class="clearfix"></div>      
      <div class="row">
        <div class="col-12">
          <div class="title-news">
            <h3  style="text-transform: uppercase;color: rgb(2, 60, 80);margin-bottom: 0px;font-size: 22px;">
              <span>{{newsDetail.title}}</span>
            </h3>
          </div>
          <hr>  
          <div class="article-content">            
            <div v-html="parseMarkdown(newsDetail.detail)"></div>            
          </div>
        </div>
        <div class="col-12">
          <RwvLatestNews />           
        </div>  
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import marked from "marked";
import store from "@/store";
import { FETCH_NEWS_DETAIL } from "@/store/actions.type";
import RwvLatestNews from "@/components/LatestNews";

export default {
  name: "RwvNewsDetail",
  props: {
    slug: {
      type: String,
      required: true
    }
  },
  components: {
    RwvLatestNews,    
  },
  beforeRouteEnter(to, from, next) {
    Promise.all([store.dispatch(FETCH_NEWS_DETAIL, to.params.slug)]).then(
      (res) => {
        console.log(res);
      }
    );

    next();
  },
  computed: {
    ...mapGetters(["newsDetail"])
  },
  methods: {
    parseMarkdown(content) {
      return marked(content);
    }
  },
  watch: {
    $route(to) {
      store.dispatch(FETCH_NEWS_DETAIL, to.params.slug);
    }
  }
};
</script>
<style >

</style>
